<template>
  <div @click="onClick"
       class="vacancy-card-small">
    <div class="relative">
      <div v-if="showRecruitingAgencyAlert" class="vacancy-card-small__recruiting-agency-alert">
        {{ $tVacancy('recruiting_agency') }}
      </div>

      <VacancyCardSmallImage
        :image="vacancy[3].images && vacancy[3].images[0]"
        :name="vacancy[1].name"
      />
    </div>

    <div class="vacancy-card-small__main">
      <div v-if="vacancy.is_hot"
           class="vacancy-card-small__label  _hot">
        <BaseSvg name="ico-flame"
                 width="1.6rem"
                 height="2rem"/>
        <span v-if="vacancy[1].work_start_text">{{ vacancy[1].work_start_text }}</span>
      </div>
      <div v-else
           class="vacancy-card-small__label">
        <BaseSvg name="ico-clock"
                 width="1.8rem"
                 height="1.8rem"/>
        <span v-if="vacancy[1].work_start_text">{{ vacancy[1].work_start_text }}</span>
      </div>

      <div class="vacancy-card-small__title">{{ vacancy[1].name }}</div>

      <VacancyCardSmallSalary :section="vacancy[1]"/>

      <div class="vacancy-card-small__row">
        <VacancyCardSmallLocation :section="vacancy[3]"/>

        <div class="vacancy-card-small__viewed">
          <BaseSvg name="ico-see"/>
          {{ vacancy.views }}
        </div>
      </div>
      <div class="vacancy-card-small__created">
        <span class="vacancy-card-small__created-title">{{ $tVacancy('Updated:') }}</span>
        <span :class="{_yellow: createdMoreThenMonth}"
              class="vacancy-card-small__created-value">{{ createdFormat }}</span>
      </div>
      <div class="vacancy-card-small__params">
        {{ (vacancy.features || []).join(' • ') }}
      </div>
      <div class="vacancy-card-small__row  _footer">
        <div v-if="!isLogged || isLoggedEmployee"
             class="vacancy-card-small__btn-wrap  _no-link">
          <div v-if="pendingBookmarks"
               class="vacancy-card-small__toggle-bookmarks  _active">
            <BaseSvg name="ico-heart"/>
            <template v-if="vacancy.in_bookmarks">
              {{ $tVacancy('Saved') }}
            </template>
            <template v-else>
              {{ $tVacancy('Save') }}
            </template>
            <BasePreloader class="_small"/>
          </div>
          <button v-else-if="vacancy.in_bookmarks"
                  @click.prevent="toggleBookmarks"
                  class="vacancy-card-small__toggle-bookmarks  _active">
            <BaseSvg name="ico-heart"/>
            {{ $tVacancy('Saved') }}
          </button>
          <button v-else
                  @click.prevent="toggleBookmarks"
                  class="vacancy-card-small__toggle-bookmarks">
            <BaseSvg name="ico-heart-outline"/>
            {{ $tVacancy('Save') }}
          </button>
        </div>

        <div style="margin-left: auto"
             class="vacancy-card-small__btn-wrap  _no-link">
          <router-link-modified :to="{
                                  name: 'vacancy',
                                  params: {
                                    vacancyId: this.vacancy[1].slug
                                  }
                                }"
                                class="vacancy-card-small__more">
            {{ $tVacancy('More details') }}
            <BaseSvg name="ico-arrow-light"/>
          </router-link-modified>
        </div>
      </div>

      <div v-if="!isLogged || isLoggedEmployee"
           class="vacancy-card-small__toggle-bookmarks-small-wrap  _no-link">
        <button v-if="vacancy.in_bookmarks"
                @click.prevent="toggleBookmarks"
                class="vacancy-card-small__toggle-bookmarks-small  _active">
          <BaseSvg name="ico-heart"/>
        </button>
        <button v-else
                @click.prevent="toggleBookmarks"
                class="vacancy-card-small__toggle-bookmarks-small">
          <BaseSvg name="ico-heart-outline"/>
        </button>
        <BasePreloader v-if="pendingBookmarks"
                       class="_small"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import VacancyCardSmallImage from './VacancyCardSmallImage'
  import VacancyCardSmallSalary from './VacancyCardSmallSalary'
  import VacancyCardSmallLocation from '@/components/vacancyCardSmall/VacancyCardSmallLocation'
  import {http} from "@/axios"
  import getDaysBetween from '@/helpers/getDaysBetween'
  import parseDate from '@/helpers/parseDate'

  export default {
    name: 'VacancyCardSmall',
    components: {
      VacancyCardSmallLocation,
      VacancyCardSmallImage,
      VacancyCardSmallSalary,
    },
    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        pendingBookmarks: false
      }
    },
    computed: {
      ...mapGetters('user', [
        'isLogged',
        'isEmployee',
      ]),

      isLoggedEmployee() {
        return this.isLogged && this.isEmployee;
      },
      created() {
        return getDaysBetween(parseDate(this.vacancy.updated_at), new Date())
      },
      createdMoreThenMonth() {
        return this.created > 30
      },
      createdFormat() {
        // "Сегодня"/"Вчера"/"2/3/4...29/30) дня(-ей) назад"/"Более месяца назад"
        const created = this.created

        if (created < 1) {
          return this.$tVacancy('Today')
        }

        if (created === 1) {
          return this.$tVacancy('Yesterday')
        }

        if (this.createdMoreThenMonth) {
          return this.$tVacancy('More than a month ago')
        }

        return created + ' ' + this.$tVacancy('days ago', created)
      },
      showRecruitingAgencyAlert() {
        return this.vacancy.employer_information?.company_type === 1;
      },
    },
    methods: {
      onClick(e) {
        if (e.target.closest('._no-link, a, button')) return

        this.$router.push({
          name: 'vacancy',
          params: {
            vacancyId: this.vacancy[1].slug
          }
        })
      },
      toggleBookmarks() {
        if (this.pendingBookmarks) return
        this.pendingBookmarks = true

        http.post(`/api/new-vacancy/set-to-bookmarks/${this.vacancy.ID}`).then(({data}) => {
          this.$emit('bookmark', data.data === 'SET')

          if (data.data === 'SET' && (!this.isLogged || data.bookmarks_count > 1)) {
            this.$vModal.open('saved-to-favorites', {
              bookmarksQuantity: data.bookmarks_count
            })
          }

          this.$store.commit('user/setProperty', ['bookmarksCount', data.bookmarks_count])
        }).finally(() => {
          this.pendingBookmarks = false
        })
      }
    }
  }
</script>

<style lang="less">

</style>
